module.exports = __webpack_public_path__ + "img/zap-square.8e90ff8c.svg";